import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ControlContainer, NgForm, NgModelGroup} from '@angular/forms';
import * as _ from 'lodash';
import {TipoConteudoRimService} from "../../../services/tipo-conteudo-rim/tipo-conteudo-rim.service";
import {TipoConteudoRim} from "../../../core/tipo-conteudo-rim";

@Component({
    selector: 'combo-tipo-conteudo-rim',
    templateUrl: './combo-tipo-conteudo-rim.component.html',
    styleUrls: ['./combo-tipo-conteudo-rim.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm},
        {provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup)}],
})
export class ComboTipoConteudoRimComponent implements OnInit {

    @ViewChild('comboTipoConteudoRim', {static: false}) comboTipoConteudoRim;

    @Input() showDisplayId;
    @Input() obrigatorio;
    @Input() selecionado;
    @Input() desabilitado;

    @Output() valorChange = new EventEmitter();

    dados = [];
    data: any = {};

    constructor(private tipoConteudoRimService: TipoConteudoRimService) {
    }

    ngOnInit(): void {
        this.data = Date.now();

        setTimeout(() => {
            this.tipoConteudoRimService.getAllCombo().subscribe((tipos: TipoConteudoRim[]) => {
                this.dados = tipos;
                this.preencherCombo();
            });
        }, 0)

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["selecionado"] && this.selecionado && this.selecionado.id) {
            this.preencherCombo();
        }
    }

    private preencherCombo() {
        if (this.selecionado && this.selecionado.id && this.dados.length) {
            this.selecionado = _.find(this.dados, {id: this.selecionado.id});
        }
    }

    onValorChange(registro: any) {
        this.valorChange.emit(registro);
        this.preencherCombo();
    }


}
